<template src="./index.html"></template>
<script>
import { Toast } from 'vant'
export default {
  name: "CustomerInfo",
  data(){
    return{
      user:{},
      contentShow: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData() {
      let params = {
        ww_nick: this.$route.query.ww_nick,
        source: this.$route.query.source,
        buyer_openuid: this.$route.query.buyer_openuid
      }

      this.$store.dispatch('CustomerInfo/getCustomerInfo',params).then(res=>{
        if(res.code == 1000) {
          this.user = res.data
          this.contentShow = true
        }else {
          Toast(res.message)
        }
      })
    },
    setUserInfo(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'客户卡片'}).then((res)=>{
        this.$router.push({ 
          path:'/SetCustomerInfo', 
          query: {source: this.$route.query.source, ww_nick: this.$route.query.ww_nick,buyer_openuid:this.$route.query.buyer_openuid}
        })
      })
      
    },
    setRemark(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'设置备注和描述'}).then((res)=>{
        this.$router.push({
          path:'/SetRemark',
          query: {source: this.$route.query.source, ww_nick: this.$route.query.ww_nick,buyer_openuid:this.$route.query.buyer_openuid}
        })
      })
    },
    setLabel(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'设置标签'}).then((res)=>{
        this.$router.push({ 
          path:'DetailsLabelPage', 
          query: {
            source: this.$route.query.source, 
            ww_nick: this.$route.query.ww_nick,
            buyer_openuid:this.$route.query.buyer_openuid
          }
        })
      })
    },
    send_message(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'客户信息页发消息'}).then((res)=>{
        this.$router.push({ 
          path:'ChatRoom', 
          query: {
            ww_nick: this.$route.query.ww_nick,
            title: this.$route.query.ww_nick,
            buyer_openuid: this.$route.query.buyer_openuid,
            is_in_list: 1,
          }
        })
      })
    },
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>